<script lang="ts">
  /* «Недоступна у поставщика» beside a product name (spec 20260915 §2.2).

     The same mark on every page where the card is managed — Products, Item
     access, Prices, Stock — so a position the supplier stopped offering is
     not lost where it is still open to clients or still on a shelf. The
     tooltip says why. Renders nothing for a card its supplier still offers. */
  import { _ } from "svelte-i18n";

  let { reason }: { reason?: string | null } = $props();

  const tip = $derived(
    reason === "access_closed"
      ? $_("gap.tip.access_closed")
      : reason === "delisted"
        ? $_("gap.tip.delisted")
        : reason === "link_ended"
          ? $_("gap.tip.link_ended")
          : "",
  );
</script>

{#if reason}
  <span class="gap-badge" title={tip}>{$_("gap.badge")}</span>
{/if}

<style>
  .gap-badge {
    display: inline-block; margin-left: 6px; padding: 1px 8px; border-radius: 10px;
    font-size: 10px; font-weight: 600; background: #fdecea; color: #c0392b;
    white-space: nowrap; vertical-align: middle; cursor: help;
  }
</style>
